import { CartPill } from 'components/CartPill/CartPill';
import { useUserEnvironmentCartPillOrgsData } from 'modules/main/store/hooks/useUserEnvironmentCartPillOrgsData';
import { useABExperimentOrgDashboardCartRoute } from 'modules/orgDashboard/hooks/useABExperimentOrgDashboardCartRoute';

export function PageHeaderCartPill() {
  const { orgsCartData } = useUserEnvironmentCartPillOrgsData();
  const orgDashboardCartRoute = useABExperimentOrgDashboardCartRoute();

  const userHasAtLeastOneOrg = Boolean(orgsCartData?.length);
  if (!userHasAtLeastOneOrg) return null;

  return (
    <CartPill
      selectedOrgId={undefined}
      getOrgCartDataHref={(orgCartData) =>
        orgDashboardCartRoute.with({ orgId: orgCartData.id })
      }
      orgsCartData={orgsCartData || []}
    />
  );
}
